import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	config: {
		funnelFeatureFlag: 'web_welcome_creatives_types_belly',
	},

	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('female_funnel.pages.landing.title_weight_loss'),
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			title: $t('female_funnel.pages.landing.subtitle_weight_loss'),
			uppercase: true,
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => ({
			img: require('@/assets/landing/belly-types.png'),
			customStyles: {
				height: '177px',
				paddingTop: 'var(--size-24)',
				paddingBottom: 'var(--size-24)',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
